import React from 'react'
import Card from 'react-bootstrap/Card';
import CardGroup from 'react-bootstrap/CardGroup';
import "./skills.scss";
import Alert from 'react-bootstrap/Alert';

export default function Skills()
{
  return (
    <div className="profileContent">
    <h1 className='title'>Mes Compétences</h1>
    <Alert variant="success">
      <Alert.Heading>bienvenue!</Alert.Heading>
      <p>
       j'aime pas évaluer mes capacités je suis Toujours en formation continue , chaque jour
       et avec chaque project j'apprends des nouvelles technologie
      </p>
      <hr />
      <p className="mb-0">
       je suis confiante en mes capacités de réaliser parfaitement mes projets
      </p>
    </Alert>
       <CardGroup>
      <Card>
        <Card.Img variant="top" className='icone' src="https://cdn.pixabay.com/photo/2017/08/05/11/16/logo-2582748_960_720.png" />
        <Card.Body>
          <Card.Title className='title'>Html</Card.Title>
          
        </Card.Body>
        
      </Card>
      <Card>
        <Card.Img variant="top" className='icone' src="https://cdn.pixabay.com/photo/2017/08/05/11/16/logo-2582747__340.png" />
        <Card.Body>
          <Card.Title className='title'>Css</Card.Title>
          
        </Card.Body>
       
      </Card>
      <Card>
        <Card.Img variant="top" className='icone' src="https://cdn-icons-png.flaticon.com/512/919/919828.png" />
        <Card.Body>
          <Card.Title className='title'>Java Script</Card.Title>
         
        </Card.Body>
       
      </Card>
    </CardGroup>
    <CardGroup>
      <Card>
        <Card.Img variant="top" className='icone' src="https://cdn-icons-png.flaticon.com/512/5968/5968332.png" />
        <Card.Body>
          <Card.Title className='title'>PHP</Card.Title>
         
        </Card.Body>
       
      </Card>
      <Card>
        <Card.Img variant="top" className='icone' src="https://cdn-icons-png.flaticon.com/512/919/919825.png" />
        <Card.Body>
          <Card.Title className='title'>Node Js</Card.Title>
         
        </Card.Body>
        
      </Card>
      <Card>
        <Card.Img variant="top" className='icone' src="https://play-lh.googleusercontent.com/AFY95yFw1P4ErzREpYWiSRyy6GyFA34pc70dP7MuHfkP12alfktC0Rp2ht-LbPAvO5sg" />
        <Card.Body>
          <Card.Title className='title'>React Js</Card.Title>
          
        </Card.Body>
       
      </Card>
    </CardGroup>
    <CardGroup>
      <Card>
        <Card.Img variant="top" className='icone' src="https://www.insitaction.com/wp-content/uploads/2021/04/symfony.png" />
        <Card.Body>
          <Card.Title className='title'>Symphony</Card.Title>
         
        </Card.Body>
        
      </Card>
      <Card>
        <Card.Img variant="top" className='icone' src="https://cdn-icons-png.flaticon.com/512/919/919836.png" />
        <Card.Body>
          <Card.Title className='title'>My SQL</Card.Title>
        
        </Card.Body>
       
      </Card>
      <Card>
        <Card.Img variant="top" className='icone' src="https://www.desuvit.com/wp-content/uploads/2021/03/mongodb-icon.png" />
        <Card.Body>
          <Card.Title className='title'>Mongo DB</Card.Title>
        
        </Card.Body>
      
      </Card>
    </CardGroup>
    </div>
  )
}
